"use client";

import React from "react";
import { Code, Smartphone, Megaphone, PenTool } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Entity Formation",
  description: "Strategic selection and formation of business entities based on ownership structure, governance needs, operational risk, and long-term business goals.",
  icon: Code
}, {
  title: "Ownership Planning",
  description: "Structuring equity, voting rights, and governance frameworks to ensure long-term stability and clear decision-making paths.",
  icon: Smartphone
}, {
  title: "Operating Agreements",
  description: "Drafting comprehensive internal documents that define member roles, capital contributions, and dispute resolution protocols.",
  icon: Megaphone
}, {
  title: "Succession & Sale",
  description: "Preparing business owners for purchase, sale, succession, or ownership transfer through clear agreements, defined obligations, and attention to the disputes that can arise when terms are unclear.",
  icon: PenTool
}];
export default function BusinessFormationOwnershipPlanning() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll();
  return;
}